import React, { Fragment, useState } from 'react';
import { css, StyleSheet } from 'aphrodite';
import Grid from '@material-ui/core/Grid';
import moment from 'moment-timezone'
import { Dialog, Tooltip } from '@material-ui/core';
import { Doughnut } from 'react-chartjs-2';
import { Helper } from '../../common/helpers/Helper';
import { BaseEntityPage } from '../../common/components/BaseEntityPage';
import { Stats } from '../../components/Stats';
import { AppUiHelper } from '../../helpers/AppUiHelper';
import { AppStyles, AppTheme } from '../../styles/AppTheme';
import { StackedBarChartDialog } from '../../common/components/charts/StackedBarChartDialog';
import { GraphHelper } from '../../common/components/charts/GraphHelper';
import { AppHelper } from '../../helpers/AppHelper';
import { GraphUiHelper } from '../../helpers/GraphUiHelper';
import { DP_DISPLAY_NAME_MAP as exchangeToTitleMap, creativeFieldsWithFieldsMandatory, ddSearchFilterFieldDef, graphColorsForEachAdTypes } from '../../data/data';
import { GraphDialog } from '../../common/components/charts/GraphDialog';
import { SearchBar } from '../../common/components/SearchBar';
import { Toast } from '../../components/Toast';
import { DynamicFormDialog } from '../../common/components/DynamicFormDialog';
import { Controller } from '../../common/Controller';
import { ApiHelper } from '../../common/helpers/ApiHelper';
import { getDownloadDeviceActivityFieldDef } from '../../data/data';
import { AppConfig } from '../../AppConfig';
import { DisplayPreviewDialog } from '../../components/DisplayPreviewDialog';
import { CreativeTagsSelector } from '../../components/CreativeTagsSelector';
import { UiHelper } from '../../common/helpers/UiHelper';
import { CreativeHistoryDialog } from '../../components/CreativeHistoryDialog';
const queryString = require('query-string');
const noViolationsAfterReviewTag = 'NO_VIOLATIONS_AFTER_REVIEW';

const mimeTypeToTitleMap = {
  image: 'Image',
  video: 'Video',
  other: 'Other'
}
export class DdSearch extends BaseEntityPage {
  pageKey = 'DdSearch';
  pageTitle = Helper.getString('DdSearch');
  orgId = this.props.match.params.orgId || 'PRODUCT';
  breadCrumbs = [
    { title: Helper.getString('home'), to: this.baseRoute() },
    { title: Helper.getString('DdSearch') },
  ];
  noAdd = true;
  state = {
    selectedDate: '',
    searchText: '',
    inProcessSearch: false,
    showToast: false,
    severity: 'info',
    toastMsg: '',
  };

  constructor(props, options) {
    super(props, options);
    this.query = queryString.parse(props.location.search);
    this.tag = this.query && this.query.tag ? this.query.tag : ''
    this.hr = this.query && this.query.hr ? this.query.hr : ''
    this.mode = this.query && this.query.mode ? this.query.mode : ''
    this.queryText = this.query && (this.query.id || this.query.query)
      ? String(this.query.id || this.query.query).trim()
      : ''
    const queryDay = this.query && this.query.day
      ? moment(String(this.query.day), ['YYYY-MM-DD', 'YYYYMMDD'], true)
      : null
    this.state = {
      ...this.state,
      searchText: this.queryText,
      filters: this.tag ? { tags: [this.tag] } : {},
      selectedDate: queryDay && queryDay.isValid()
        ? queryDay.format('YYYY-MM-DD')
        : ((this.tag || this.queryText) ? '' : moment().subtract(1, 'day').format('YYYY-MM-DD'))
    }
    this.chartOptions = GraphHelper.getdoughnutChartOptions()
    this.export = {
      buttonTitle: 'Download',
      headers: {},
      format: 'xlsx'
    }
    this.noTableHead = true
    this.tableHeadersMap = {
      Index: (current) => current.__index + 1,
      Content: (current) => {
        const mimeType = ((current && current.mimetype) || '').toLowerCase()
        const isVideo = mimeType.startsWith('video/')
        const isImage = mimeType.startsWith('image/')
        const frameUrl = current.frameUrls && current.frameUrls[0]
        let mediaUrl = current.adUrl || current.url
        if (isVideo) {
          mediaUrl = frameUrl || current.adUrl
        } else if (isImage) {
          mediaUrl = current.adUrl
        }

        return (
          <div>
            {isVideo
              ? AppUiHelper.renderVideoThumbnailCustomStyle({ content: mediaUrl }, {}, { _IMAGEFIT: false })
              : isImage
                ? AppUiHelper.itemImage({ ...current, _IMAGEFIT: false, image: mediaUrl })
                : <i className={'material-icons-outlined ' + css(Styles.icons)}>insert_drive_file</i>}
          </div>
        )
      },
      Info: (current) => {
        const mimeType = ((current && current.mimetype) || '').toLowerCase()
        const mediaTypeLabel = mimeType.startsWith('video/')
          ? 'VIDEO'
          : mimeType.startsWith('image/')
            ? 'IMAGE'
            : 'OTHER'
        const infoParts = [
          current.advertiserDomains && current.advertiserDomains.join(','),
          current.iabCategories && current.iabCategories.join(','),
          current.buyer,
          current.adRating,
          current.campaignNames && current.campaignNames.join(','),
          current.adTitle,
          current.adSystems && current.adSystems.join(','),
        ].filter(Boolean)
        const renderOpt = { hidePop: true, showDropped: true, showContentDropped: true }
        return (
          <div className={css(Styles.infoBlock)}>
            <div>
              <span className={css(Styles.spanValue)}>
                {mediaTypeLabel}
                {current.durationsecs ? ` | ${current.durationsecs} Secs` : ''}
              </span>
            </div>
            <div>
              {current.exchange &&
                <Fragment>
                  <span className={css(Styles.spanValue)}>Exchange: {exchangeToTitleMap[current.exchange] || current.exchange}</span>
                </Fragment>
              }
            </div>
            {current.descr &&
              <div className={css(Styles.descrText)}>
                {current.descr}
              </div>
            }
            {current.tags && current.tags.length > 0 &&
              <div className={css(Styles.tagHolder)}>
                <span>AI Tags: </span>
                {current.tags.map((tag, index) => (
                  <span key={`tag_${index}`} className={css(Styles.tagChip)}>
                    {tag}
                  </span>
                ))}
              </div>
            }
            {Array.isArray(current.validatedTags) &&
              <div className={css(Styles.tagHolder)}>
                <span>Reviewer Tags: </span>
                {current.validatedTags.length === 0
                  ? AppUiHelper.chipGreen(noViolationsAfterReviewTag, false)
                  : current.validatedTags.map((tag, index) => (
                    AppUiHelper.chipPurple(tag, false)
                  ))}
              </div>
            }
            {current.createdTs &&
              <Fragment>
                <span className={css(Styles.spanValue)}>Leased Timestamp (CST): {Helper.formatDate2({ utcTimestamp: current.createdTs, format: 'Do MMM YYYY, h:mm a' })}</span>
              </Fragment>
            }
            {current.firstApprovalTs &&
              <Fragment>
                <span className={css(Styles.spanValue)}>First Approval Timestamp (CST): {Helper.formatDate2({ utcTimestamp: current.firstApprovalTs, format: 'Do MMM YYYY, h:mm a' })}</span>
              </Fragment>
            }
            {current.firstRejectionTs &&
              <Fragment>
                <span className={css(Styles.spanValue)}>First Rejection Timestamp (CST): {Helper.formatDate2({ utcTimestamp: current.firstRejectionTs, format: 'Do MMM YYYY, h:mm a' })}</span>
              </Fragment>
            }
            {current.stateChangeReason &&
              <Fragment>
                <span className={css(Styles.spanValue)}>State Change Reason: {current.stateChangeReason}</span>
              </Fragment>
            }
            <div>
              {infoParts.join(' | ')}
            </div>
            {GraphUiHelper.renderCreativeStats(current, renderOpt)}
            {current.id &&
              <div>
                <span className={css(Styles.spanValue)}>Creative ID: {current.id}</span>
              </div>
            }
            {current.admJbStatus &&
              <div className={css(Styles.aiJobStatusLine)}>
                <span className={css(Styles.spanValue)}>AI Analysis #id: {current.admJbId} | Status:</span>
                {[].concat(current.admJbStatus).map((status, index) => (
                  <span key={`admJbStatus_${index}`} className={css(Styles.statsValueText)}>
                    {status}
                  </span>
                ))}
              </div>
            }
          </div>
        )
      },
      ReviewStatus: (current) => {
        return (
          <div>
            {(!current.state || (current.state === 'APPROVED'))
              ? AppUiHelper.chipGreen('APPROVED')
              : ((!current.state || (current.state === 'REJECTED')) ? AppUiHelper.chipError('REJECTED') : (current.state === 'DROPPED') ? AppUiHelper.chipError('DROPPED') : AppUiHelper.chipError('HOLD'))}
          </div>
        )
      }
    }
    this.tableHeaders = Object.keys(this.tableHeadersMap);
    this.toFetch = this.makeFetches();
  }

  getTotalStats = () => {
    const total = (this.state.fieldsstats_ && this.state.fieldsstats_.count) || 0
    if (this.mode === 'review-queue') {
      const selectedDate = this.formatSelectedDate(this.state.selectedDate)
      return [
        {
          title: 'Date',
          value: selectedDate
            ? moment(selectedDate, 'YYYY-MM-DD').format('Do MMM YYYY')
            : '-',
          image: require('../../assets/icons/stats/duration.svg')
        },
        {
          title: 'Pending Review',
          value: AppHelper.formatNumberStats(total),
          image: require('../../assets/icons/venueStatus/orientation.svg')
        }
      ]
    }
    return [{
      title: 'Total',
      value: AppHelper.formatNumberStats(total),
      image: require('../../assets/icons/partner-reports/creative.svg')
    }]
  }

  getDdSearchGraphPalette = () => {
    return [
      '#9B59B6',
      '#F79D65',
      '#3FA5D6',
      '#2029F1',
      '#CDB4DB',
      '#2F2E41',
      '#E4B08A',
      '#6E84A3',
      '#FFC8DD',
      '#575757',
      '#B8C0FF',
      '#D4A373',
      '#1E90FF',
      '#E4C1F9',
      '#F2C14E',
      '#3F3D56',
      '#747474',
      '#F6BD60',
      '#90DBF4',
      '#FDE4CF',
      '#A2D2FF',
      '#A0616A',
      '#BDE0FE',
      '#E9D8A6',
      '#A9DEF9',
      '#CDDAF5',
      '#DDBEA9',
      '#C9CBA3',
      '#F7B267',
      '#B7B7A4'
    ]
  }

  makeDdSearchDoughnutData = ({ chartTitle, values }) => {
    const labels = values.map((item) => `${item.label} (${AppHelper.formatNumberStats(item.value)})`)
    const data = values.map((item) => item.value)
    const colors = this.getDdSearchGraphPalette().slice(0, values.length)

    return {
      chartTitle,
      data: {
        labels,
        datasets: [
          {
            data,
            backgroundColor: colors,
            borderColor: colors,
            hoverBackgroundColor: colors,
            borderWidth: 0
          }
        ]
      },
      hasDataMoreThanZero: data.some((value) => value > 0),
      latestError: {}
    }
  }

  formatRangeDistributionLabel = (key, unit) => {
    const labelMap = {
      below5: `Below 5${unit}`,
      below10: `< 10${unit}`,
      from10to20: `10${unit} to <20${unit}`,
      from11below20: `11${unit} to <20${unit}`,
      from10below20: `10${unit} to <20${unit}`,
      from20below30: `20${unit} to <30${unit}`,
      from30below40: `30${unit} to <40${unit}`,
      from40to60: `40${unit} to <60${unit}`,
      from41below60: `41${unit} to <60${unit}`,
      from40below60: `40${unit} to <60${unit}`,
      from5below10: `5${unit} to <10${unit}`,
      from10below15: `10${unit} to <15${unit}`,
      from15below20: `15${unit} to <20${unit}`,
      from20below50: `20${unit} to <50${unit}`,
      from50up: `50${unit} and above`,
      from60up: `60${unit} and above`,
    }

    return labelMap[key] || key
  }

  getMimeTypeDistributionValues = () => {
    const facets = (this.state.fieldsstats_ && this.state.fieldsstats_.facets) || []
    const mimeFacet = facets.find((facet) => facet && facet.key === 'mimetype')
    const mimeValues = (mimeFacet && mimeFacet.values) || []

    const totals = mimeValues.reduce((acc, item) => {
      const mimeType = ((item && item.value) || '').toLowerCase()
      const count = (item && item.count) || 0

      if (mimeType.startsWith('image/')) {
        acc.images += count
        return acc
      }

      if (mimeType.startsWith('video/')) {
        acc.videos += count
        return acc
      }

      acc.others += count
      return acc
    }, {
      images: 0,
      videos: 0,
      others: 0
    })

    return [
      { label: 'Images', value: totals.images },
      { label: 'Videos', value: totals.videos },
      { label: 'Others', value: totals.others }
    ]
  }

  getDurationDistributionValues = () => {
    const durationDistribution = (this.state.fieldsstats_ && this.state.fieldsstats_.durationDistribution) || []

    return durationDistribution.map((item) => ({
      label: this.formatRangeDistributionLabel(item.key || item.label, 's'),
      value: Number(item.count) || 0
    }))
  }

  getBitrateDistributionValues = () => {
    const bitrateDistribution = (this.state.fieldsstats_ && this.state.fieldsstats_.bitrateDistribution) || []

    return bitrateDistribution.map((item) => ({
      label: this.formatRangeDistributionLabel(item.key || item.label, ' Mbps'),
      value: Number(item.count) || 0
    }))
  }

  getExchangeDistributionValues = () => {
    const facets = (this.state.fieldsstats_ && this.state.fieldsstats_.facets) || []
    const exchangeFacet = facets.find((facet) => facet && facet.key === 'exchange')
    const exchangeValues = (exchangeFacet && exchangeFacet.values) || []

    return exchangeValues.map((item) => ({
      label: exchangeToTitleMap[item.value] || item.value,
      value: Number(item.count) || 0
    }))
  }

  getOrientationDistributionValues = () => {
    const facets = (this.state.fieldsstats_ && this.state.fieldsstats_.facets) || []
    const orientationFacet = facets.find((facet) => facet && facet.key === 'orientation')
    const orientationValues = (orientationFacet && orientationFacet.values) || []

    const totals = orientationValues.reduce((acc, item) => {
      const rawValue = ((item && item.value) || '').toLowerCase()
      const count = Number(item && item.count) || 0

      if (!rawValue) return acc
      acc[rawValue] = (acc[rawValue] || 0) + count
      return acc
    }, {})

    return Object.keys(totals).map((key) => ({
      label: key.toUpperCase(),
      value: totals[key]
    }))
  }

  getIabCategoryDistributionValues = () => {
    const facets = (this.state.fieldsstats_ && this.state.fieldsstats_.facets) || []
    const iabFacet = facets.find((facet) => facet && facet.key === 'iabCategories')
    const iabValues = (iabFacet && iabFacet.values) || []

    return iabValues.map((item) => ({
      label: item.value,
      value: Number(item.count) || 0
    }))
  }

  getTagsDistributionValues = () => {
    const stats = this.state.fieldsstats_ || {}
    const facets = stats.facets || []
    const tagsFacet = facets.find((facet) => facet && facet.key === 'tags')
    const tagValues = (tagsFacet && tagsFacet.values) || []

    return tagValues.map((item) => ({
      label: item.value,
      value: Number(item.count) || 0
    }))
  }

  getTotalGraphData = () => {
    return [
      this.makeDdSearchDoughnutData({
        chartTitle: 'Media Type',
        values: this.getMimeTypeDistributionValues()
      }),
      this.makeDdSearchDoughnutData({
        chartTitle: 'Duration',
        values: this.getDurationDistributionValues()
      }),
      this.makeDdSearchDoughnutData({
        chartTitle: 'Bitrate',
        values: this.getBitrateDistributionValues()
      }),
      this.makeDdSearchDoughnutData({
        chartTitle: 'Exchange',
        values: this.getExchangeDistributionValues()
      }),
      this.makeDdSearchDoughnutData({
        chartTitle: 'Orientation',
        values: this.getOrientationDistributionValues()
      }),
      // this.makeDdSearchDoughnutData({
      //   chartTitle: 'IAB Category Distribution',
      //   values: this.getIabCategoryDistributionValues()
      // }),
      this.makeDdSearchDoughnutData({
        chartTitle: 'Tags',
        values: this.getTagsDistributionValues()
      })
    ]
  }

  formatSelectedDate = (selectedDate) => {
    if (!selectedDate) return ''
    if (typeof selectedDate === 'string') return selectedDate
    const parsed = moment(selectedDate)
    return parsed.isValid() ? parsed.format('YYYY-MM-DD') : ''
  }

  clearUrlQueryParams = () => {
    if (this.props.history && this.props.location && this.props.location.pathname) {
      this.props.history.replace(this.props.location.pathname)
    }
    this.query = {}
    this.tag = ''
    this.hr = ''
  }

  makeFetches = () => {
    const { searchText, filters, selectedDate } = this.state;
    const queryParams = {
      limit: 1000
    }

    const formattedSelectedDate = this.formatSelectedDate(selectedDate)
    if (formattedSelectedDate) {
      queryParams.day = formattedSelectedDate.replaceAll('-', '')
    }

    if (searchText) {
      queryParams.query = [searchText.trim()]
    }

    if (this.hr) {
      queryParams.hr = String(this.hr).trim()
    }

    if (this.mode === 'review-queue') {
      queryParams.mode = this.mode
    }

    for (const key in filters) {
      if (filters[key] && filters[key].length > 0) {
        queryParams[key] = filters[key]
      }
    }

    return [{ method: 'GET', paths: ['miscs', 'creativesearch'], queryParams }];
  };

  refreshSearchResults = () => {
    this.toFetch = this.makeFetches();

    ApiHelper.call(this.toFetch[0], (err, result) => {
      if (err) {
        this.setState({
          inProcessSearch: false,
          nextPageState: ApiHelper.State.READY,
          fetchState: ApiHelper.State.READY
        });
        this.onError(Helper.getErrorMsg(err));
        return
      }

      this.onFetchSuccess([result]);
      this.setState({
        fetchState: ApiHelper.State.READY,
        preview: false
      });
    });
  }

  onError = (toastMsg) => {
    this.setState({
      showToast: true,
      severity: 'error',
      toastMsg
    });
  }

  getToast = () => {
    return (
      <Toast
        open={this.state.showToast}
        severity={this.state.severity}
        message={this.state.toastMsg}
        handleClose={() => this.setState({ showToast: false })}
      />
    )
  }

  onFetchSuccess = (results, opts) => {
    const { fetchNext } = opts || {}
    this.formDefinition = creativeFieldsWithFieldsMandatory.fieldDef
    this.handleNextpage(results[0])
    if (!this.filterFormDefinition) {
      this.filterFormDefinition = JSON.parse(JSON.stringify(ddSearchFilterFieldDef.fieldDef))
    }
    this.appendFacetOptions(this.filterFormDefinition, results[0] && results[0].stats)
    const newItems = this.normalizeItems(results[0] && results[0].items ? results[0].items : [])
    this.export.headers = this.getDdSearchExportHeaders(fetchNext ? this.state.items.concat(newItems) : newItems)
    this.setState({
      items: fetchNext ? this.state.items.concat(newItems) : newItems,
      fieldsstats_: results[0].stats || {},
      inProcessSearch: false,
      nextPageState: ApiHelper.State.READY
    });
  };

  normalizeItems = (items = []) => {
    return items.map((item) => ({
      ...item,
      mediaErrorDropped: (Number(item.invalidBrDropped) || 0) + (Number(item.invalidSizeDropped) || 0)
    }))
  }

  onSearch = async (searchText) => {
    const trimmed = (searchText || '').trim()
    this.clearUrlQueryParams()

    if (!trimmed) {
      this.setState(
        { searchText: '', viewMode: 'all', inProcessSearch: true },
        () => {
          this.refreshSearchResults();
        }
      )
      return
    }

    this.setState(
      { searchText: trimmed, inProcessSearch: true },
      () => {
        this.refreshSearchResults();
      }
    )
  }

  onList = async () => {
    if (this.searchBarComponent) this.searchBarComponent.setState({ searchText: '' })
    this.clearUrlQueryParams()
    this.setState(
      {
        searchText: '',
        viewMode: 'all',
        filters: {},
        selectedDate: '',
        inProcessSearch: true
      },
      () => {
        this.refreshSearchResults();
      }
    )
  }


  renderAboveTable = () => {
    const totalStats = this.getTotalStats();
    const totalGraphData = this.getTotalGraphData();
    return (
      <div className={css(Styles.renderAboveTable)}>

        {this.mode !== 'review-queue' && <div className={css(Styles.singleFilterBar)}>
          <div className={css(Styles.searchContainer)}>
            <SearchBar
              ref={(child) => (this.searchBarComponent = child)}
              hint={Helper.getString('ddSearchHint')}
              inProcessSearch={this.state.inProcessSearch || false}
              callSearchOnEmptyText={true}
              // onList={this.onList}
              resetFilterText={'Reset Filter'}
              onSearch={this.onSearch.bind(this)}
              searchText={this.state.searchText}
              showRecentButtonText={'Search'}
            />
          </div>
          <span
            className={css(Styles.filterIconWrap)}
            onClick={() => this.setState({ showFilterDialog: true })}
          >
            <i className='material-icons-outlined' style={{ fontSize: 20, color: '#020BC3', lineHeight: 1, display: 'block' }}>
              settings
            </i>
          </span>
        </div>}
        {this.mode !== 'review-queue' && this.renderActiveFilters()}
        <Stats items={totalStats} md={this.mode === 'review-queue' ? 6 : 12} lg={this.mode === 'review-queue' ? 6 : 12}></Stats>
        {this.mode !== 'review-queue' && totalGraphData.length > 0 &&
          <Grid className={css(Styles.chartsContainer)} container spacing={2}>
            {totalGraphData.map((x, index) => {
              if (!x.data.datasets[0].data || x.data.datasets[0].data.length === 0) return ''
              return (
                <Grid item key={'chart_' + index} className={css(Styles.eachChartHolder)} xs={12} md={4}>
                  <div className={css(Styles.chartOuterWrap)}>
                    <div className={css(Styles.chartBlock)}>
                      {x.chartTitle &&
                        <div className={css(Styles.chartTitle)}>{x.chartTitle}</div>
                      }
                      {x.hasDataMoreThanZero === false ?
                        <div className={css(Styles.noChartMessage)}>{Helper.getString('noChartDataMessage')}</div> :
                        <Doughnut className={css(Styles.chartCanvas)} data={x.data} options={this.chartOptions} width={100} height={100} />}
                    </div>
                  </div>
                </Grid>
              )
            })}
          </Grid>
        }
        {this.state.showDownloadPerDeviceDialog && (
          <DynamicFormDialog
            customSubmit={this.submitDownloadPerDeviceJob}
            formDefinition={getDownloadDeviceActivityFieldDef().fieldDef}
            isOpen={this.state.showDownloadPerDeviceDialog}
            onClosed={() => this.setState({ showDownloadPerDeviceDialog: false })}
          />
        )}
        {this.getToast()}
        {this.renderDetailsDialog()}
        {this.renderPreviewDialogs()}
        {this.renderHistoryDialog()}
        {this.renderFilterDialog()}
      </div>
    );
  };

  onTableValue(current, index) {
    if (!this.tableHeaders[index]) return ''
    return this.tableHeadersMap[this.tableHeaders[index]](current)
  }

  previewButton(current) {
    return (
      <Tooltip title='Review' placement='top-start' key={(current.id || current.__index) + 'Review'}>
        <span className={css(AppStyles.entityTableLinkIcon)}>
          <img className={css(Styles.actionIconImage)} src={require('../../assets/icons/user-blue.svg')} onClick={() => { this.setState({ preview: true, current }) }} />
        </span>
      </Tooltip>
    )
  }

  infoButton(current) {
    return (
      <Tooltip title='Info' placement='top-start' key={(current.id || current.__index) + 'Info'}>
        <span className={css(AppStyles.entityTableLinkIcon)}>
          <img className={css(Styles.actionIconImage)} src={require('../../assets/icons/info-circle.svg')} onClick={() => { this.setState({ showDetails: true, current }) }} />
        </span>
      </Tooltip>
    )
  }

  reviewButton(current) {
    return (
      <Tooltip title='Info' placement='top-start' key={(current.id || current.__index) + 'Info'}>
        <span className={css(AppStyles.entityTableLinkIcon)}>
          <img className={css(Styles.actionIconImage)} src={require('../../assets/icons/info-circle.svg')} onClick={() => { this.setState({ showDetails: true, current }) }} />
        </span>
      </Tooltip>
    )
  }

  historyButton(current) {
    return (
      <Tooltip title='Creative History' placement='top-start' key={(current.id || current.__index) + 'History'}>
        <span className={css(AppStyles.entityTableLinkIcon)}>
          <i className='material-icons-outlined' style={{ fontSize: 20 }} onClick={() => { this.setState({ showHistory: true, currentHistoryItem: current }) }}>track_changes</i>
        </span>
      </Tooltip>
    )
  }

  onActions(current) {
    const actions = []
    UiHelper.addActionButtonByRole(actions, this.previewButton(current), [])
    return actions
  }

  onEdit(current) {
    this.setState({
      apiMethod: 'PUT',
      apiEndPoint: ApiHelper.makeUrlPath(['miscs', 'creatives']),
      apiData: {
        orgId: this.orgId,
        creativeId: current.id
      }
    });
  }

  formatDetailValue(key, value) {
    if (value === undefined || value === null || value === '') return '-'
    if (key === 'createdTs') return Helper.formatTimestamp(value)
    if (typeof value === 'boolean') return value ? 'true' : 'false'
    if (Array.isArray(value)) return value.length > 0 ? value.join(', ') : '-'
    if (typeof value === 'object') return JSON.stringify(value, null, 2)
    return value
  }

  getDetailMeta = () => {
    return {
      advertiserDomains: {
        title: 'Advertiser Domains',
        descr: 'Website domains associated with the advertiser or brand being promoted. Helps identify the advertiser behind the creative (e.g., tangluck.com, sharecare.com).'
      },
      iabCategories: {
        title: 'IAB Categories',
        descr: 'Standard IAB industry categories assigned to the ad content, such as Automotive, Business, Sports, Entertainment, etc.'
      },
      durationsecs: {
        title: 'Ad Duration',
        descr: 'Length of the video creative in seconds. Common values are 15, 30, and 60 seconds.'
      },
      mimetype: {
        title: 'Media Type',
        descr: 'Technical format of the creative asset, such as video/mp4, image/jpeg, or image/png.'
      },
      orientation: {
        title: 'Orientation',
        descr: 'Creative layout orientation derived from asset dimensions. Typical values are landscape, portrait, or square.'
      },
      exchange: {
        title: 'Exchange',
        descr: 'Advertising exchange or SSP that delivered the ad. Examples include PO (Place Exchange OTT), PU (Publica), VS (Vistar), and IN (Indicue).'
      },
      publisherDomains: {
        title: 'Publisher Domains',
        descr: 'Publisher, inventory, or content-owner domains associated with where the ad was served or intended to run.'
      },
      adSystems: {
        title: 'Ad Systems',
        descr: 'Ad-serving platforms or technologies involved in generating or delivering the VAST response, such as AdServer, FreeWheel, Google DCM/DBM, or Vesta.'
      },
      buyer: {
        title: 'Buyer',
        descr: 'Buyer, advertiser account, DSP account, or entity that purchased the advertising impression.'
      },
      buyerSeat: {
        title: 'Buyer Seat',
        descr: 'Seat, account, or buying platform through which the buyer participated in the auction or transaction.'
      },
      campaignNames: {
        title: 'Campaign Name',
        descr: 'Campaign name or campaign identifier associated with the creative and advertising purchase.'
      },
      pricingCpm: {
        title: 'CPM',
        descr: 'Cost Per Mille (cost per 1,000 impressions) associated with the ad transaction or winning bid.'
      },
      adTechPartners: {
        title: 'Ad Tech Partners',
        descr: 'Third-party technology vendors involved in ad serving, measurement, verification, attribution, fraud detection, or analytics.'
      },
      adTitle: {
        title: 'Ad Title',
        descr: 'Human-readable title or name of the creative as provided in the VAST response.'
      },
      descr: {
        title: 'Analysis of the Ad'
      },
      descr2: {
        title: 'Text Extracted from Frames'
      },
      polSocScore: {
        title: 'Political/Social Sensitivity Score (0-10)'
      },
      tags: {
        title: 'Tags'
      },
      admJbStatus:{
        title: 'Ad Analysis Status'
      },
      state: {
        title: 'State',
        descr: 'Whether ad is approved or rejected based on the content'
      },
      adRating: {
        title: 'Ad Rating',
        descr: 'Content suitability or audience rating assigned to the ad, such as G, PG, T, or other exchange-specific ratings.'
      },
      pricingCurrency: {
        key: 'pricingCurrency',
        title: 'Currency',
        descr: 'Currency used for CPM and pricing values associated with the ad transaction. Common values include USD, EUR, GBP, INR, and other ISO currency codes.'
      },
    }
  }

  getDdSearchExportHeaders = (items = []) => {
    const headers = {
      id: 'Creative ID',
      adUrl: 'Ad Url',
      mimetype: 'MIME Type',
      tags: 'AI Tags',
      validatedTags: 'Reviewer Tags',
      durationsecs: 'Duration (Secs)',
      leased: 'Leased Ads',
      served: 'Served Ads',
      dropped: 'Dropped Ads (bitrate)',
      contentDropped: 'Dropped Ads (blocked content)',
      mediaErrorDropped: 'Media Error Dropped',
      maxDurDropped: 'Max Duration Exceeded Dropped',
      aiAnalysisPendingDropped: 'AI Analysis Pending Dropped',
      exchange: 'Exchange',
      createdTs: 'Leased Timestamp (CST)',
      firstApprovalTs: 'First Approval Timestamp (CST)',
      firstRejectionTs: 'First Rejection Timestamp (CST)',
      stateChangeReason: 'State Change Reason',
      state: 'State',
      advertiserDomains: 'Advertiser Domains',
      iabCategories: 'IAB Categories',
      buyer: 'Buyer',
      adRating: 'Ad Rating',
      campaignNames: 'Campaign Names',
      adTitle: 'Ad Title',
      adSystems: 'Ad Systems',
      admJbId: 'AI Analysis ID',
      admJbStatus: 'AI Job Status'
    }
    const detailMeta = this.getDetailMeta()
    const excludedDetailKeys = ['facet', 'id', 'groupId', 'adUrl', '__index','frameUrls','admJbCmpltTs']
    const explicitKeys = Object.keys(headers)

    items.forEach((item) => {
      Object.keys(item || {}).forEach((key) => {
        if (excludedDetailKeys.includes(key) || explicitKeys.includes(key)) return
        headers[key] = (detailMeta[key] && detailMeta[key].title) || key
      })
    })

    return headers
  }

  prepExcelDownload() {
    const rows = [];

    for (const item of this.state.items || []) {
      const e = {};
      for (const hKey in this.export.headers) {
        e[this.export.headers[hKey]] = this.exportRowItemValue(hKey, item)
      }
      rows.push(e);
    }
    return rows
  }

  makeFileName = () => {
    return `Exchange-Creatives-${moment().format('YYYY-MM-DD-HH:mm:ss')}`
  }

  exportRowItemValue(key, current) {
    switch (key) {
    case 'mimetype':
      return current[key] || ''
    case 'exchange':
      return exchangeToTitleMap[current[key]] || current[key] || ''
    case 'createdTs':
    case 'firstApprovalTs':
    case 'firstRejectionTs':
      return current[key] ? Helper.formatDate2({ utcTimestamp: current[key], format: 'Do MMM YYYY, h:mm a' }) : ''
    case 'state':
      return current[key] || 'APPROVED'
    case 'validatedTags':
      return Array.isArray(current[key])
        ? (current[key].length === 0 ? noViolationsAfterReviewTag : current[key].join(', '))
        : ''
    default:
      if (Array.isArray(current[key])) return current[key].join(', ')
      if (typeof current[key] === 'boolean') return current[key] ? 'true' : 'false'
      return current[key] || ''
    }
  }

  renderActiveFilters = () => {
    const { filters, selectedDate } = this.state;
    const normalizedFilters = filters || {};
    if (!filters && !selectedDate) return null;

    const labelMap = {
      exchange: 'Exchange',
      iabCategories: 'IAB Category',
      tags: 'Tags',
      mimetype: 'MIME Type',
      durationsecs: 'Duration',
      adRating: 'Ad Rating',
      orientation: 'Orientation',
      state: 'State'
    };

    const activeFilters = Object.entries(normalizedFilters).filter(([key, value]) => {
      if (key === 'REMOVE_ATTRS') return false
      if (Array.isArray(value)) return value.filter((item) => item && item !== '_ALL').length > 0
      return value && value !== '_ALL'
    });

    if (activeFilters.length === 0 && !selectedDate) return null;

    return (
      <div className={css(Styles.filterChipsRow)}>
        {selectedDate && (
          <div key='selectedDate' className={css(Styles.filterChip)}>
            Date: {Helper.formatDate3({ date: selectedDate, inputFormat: 'YYYY-MM-DD', outputFormat: 'Do MMM YYYY', suffix: ' (CST)' })}
          </div>
        )}
        {activeFilters.map(([key, value]) => (
          <div key={key} className={css(Styles.filterChip)}>
            {labelMap[key] || key}: {Array.isArray(value)
              ? value.map((item) => {
                if (key === 'exchange') return exchangeToTitleMap[item] || item
                if (key === 'mimetype') return mimeTypeToTitleMap[item] || item
                if (key === 'durationsecs') return this.formatRangeDistributionLabel(item, 's')
                return item
              }).join(', ')
              : (key === 'exchange'
                ? (exchangeToTitleMap[value] || value)
                : (key === 'mimetype'
                  ? (mimeTypeToTitleMap[value] || value)
                  : (key === 'durationsecs' ? this.formatRangeDistributionLabel(value, 's') : value)))}
          </div>
        ))}
        {(activeFilters.length > 0 || selectedDate) && (
          <button className={css(Styles.filterResetButton)} onClick={this.onList} type='button'>
            Reset Filter
          </button>
        )}
      </div>
    );
  };

  renderDetailsDialog() {
    if (!this.state.showDetails || !this.state.current) return ''
    const current = this.state.current
    const excludedDetailKeys = ['facet', 'id', 'groupId', 'adUrl', '__index', 'admJbCmpltTs', 'frameUrls']
    const detailMeta = this.getDetailMeta()
    const detailRows = Object.keys(current).filter((key) => !excludedDetailKeys.includes(key)).map((key) => {
      if(key === 'createdTs') return ''
      if(key === 'firstApprovalTs') return ''
      const value = this.formatDetailValue(key, current[key])
      const isMultiline = typeof value === 'string' && value.indexOf('\n') > -1
      const meta = detailMeta[key] || {}
      return (
        <div className={css(Styles.detailRow)} key={key}>
          <div className={css(Styles.detailKey)}>
            <div>{meta.title || key}</div>
            {meta.descr && <div className={css(Styles.detailDescr)}>{meta.descr}</div>}
          </div>
          <div className={css(Styles.detailValue)}>
            {isMultiline ? <pre className={css(Styles.detailPre)}>{value}</pre> : value}
          </div>
        </div>
      )
    })

    return (
      <Dialog
        open={this.state.showDetails ? true : false}
        aria-labelledby='creative-details'
        fullWidth={true}
        maxWidth='md'
        classes={{
          root: css(Styles.dialogRoot),
          paper: css(Styles.dialogPaper),
        }}
      >
        <div className={css([Styles.modalHeader, AppStyles.modalHeader])}>
          <button className={css(Styles.modalCloseButton)} onClick={() => this.setState({ showDetails: false })}>
            {UiHelper.renderImg({ key: 'dialogCloseIcon' })}
          </button>
        </div>
        <div className={css(Styles.detailContent)}>
          {detailRows}
        </div>
      </Dialog>
    )
  }

  onMenuItems = (current) => {
    const actions = []
    // if (current.state !== 'DROPPED') {
    //   actions.push(
    //     <Tooltip title='Approve or Block' placement='top-start' key={(current.id || current.__index) + '-review'}>
    //       <span className={css(AppStyles.entityTableLinkIcon)}>
    //         <i className='material-icons-outlined' style={{ fontSize: 20 }} onClick={() =>
    //           this.openModalForEdit.bind(this)(current)
    //         }>flaky</i>
    //       </span>
    //     </Tooltip>
    //   )
    // }
    const menuItems = [
      {
        current: current,
        key: (current.id || current.__index) + '-info',
        action: () => {
          this.setState({ showDetails: true, current })
        },
        title: 'Info',
        icon: 'info',
      },
      {
        current: current,
        key: (current.id || current.__index) + '-review',
        action: () => {
          this.openModalForEdit.bind(this)(current)
        },
        title: Helper.getString('ApproveOrBlock'),
        icon: 'flaky',
      },
      {
        current: current,
        key: (current.id || current.__index) + '-history',
        action: () => {
          this.setState({ showHistory: true, currentHistoryItem: current })
        },
        title: 'Creative History',
        icon: 'track_changes',
      },
    ]
    menuItems.map(item => {
      actions.push(UiHelper.actionButton(item))
    })
    return actions
  }

  renderPreviewDialogs() {
    if (!this.state.preview || !this.state.current) return '';
    return (
      <DisplayPreviewDialog
        isOpen={this.state.preview ? true : false}
        adLink={this.state.current.adUrl}
        mediaType={this.state.current.mimetype}
        onClosed={() => this.setState({ preview: undefined })}
      >
        <CreativeTagsSelector
          current={this.state.current}
          tagOptions={this.getTagOptionsForSelector()}
          orgId={this.orgId}
          onSaved={this.onCreativeTagsSaved}
        />
      </DisplayPreviewDialog>
    )
  }
  getTagOptionsForSelector = () => {
    const tagsField = this.filterFormDefinition &&
      this.filterFormDefinition.steps[0].fields.find((field) => field.key === 'tags')

    return (tagsField && tagsField.options) || []
  }

  onCreativeTagsSaved = (validatedTags) => {
    if (this.mode === 'review-queue') {
      const current = this.state.current
      if (!current) return

      const updatedValidatedTags = Array.isArray(validatedTags) ? [...validatedTags] : []
      const updatedCurrent = {
        ...current,
        validatedTags: updatedValidatedTags
      }
      const items = (this.state.items || []).map((item) => {
        if (item === current || (item.id && item.id === current.id)) return updatedCurrent
        return item
      })

      this.setState({
        current: updatedCurrent,
        items,
        fetchState: ApiHelper.State.READY,
        preview: false
      })
    } else {
      this.refreshSearchResults();
    }
  }

  renderHistoryDialog() {
    return (
      <CreativeHistoryDialog
        current={this.state.currentHistoryItem}
        orgId={this.orgId}
        title='Creative History'
        isOpen={this.state.showHistory ? true : false}
        onClosed={() => this.setState({ showHistory: false })}
      />
    )
  }

  onFilterSubmit = (data) => {
    const { formData } = data;
    const { filterDate } = formData || {};
    const filters = Object.keys(formData || {}).reduce((acc, key) => {
      if (key === 'filterDate') return acc
      const value = formData[key]
      if (Array.isArray(value)) {
        const cleanedValues = value.filter((item) => item && item !== '_ALL')
        if (cleanedValues.length > 0) {
          acc[key] = cleanedValues
        }
        return acc
      }
      if (value && value !== '_ALL') {
        acc[key] = value
      }
      return acc
    }, {})
    this.clearUrlQueryParams()
    this.setState({
      showFilterDialog: false,
      inProcessSearch: true,
      selectedDate: this.formatSelectedDate(filterDate),
      filters,
    }, () => {
      this.refreshSearchResults();
    });
  };

  appendFacetOptions = (formDefinition, stats) => {
    const facets = stats && stats.facets
    const durationDistribution = (stats && stats.durationDistribution) || []
    const facetMap = (Array.isArray(facets) ? facets : []).reduce((acc, facet) => {
      if (facet && facet.key) {
        acc[facet.key] = facet.values || []
      }
      return acc
    }, {})

    formDefinition.steps[0].fields.forEach((field) => {
      // Keep static labels for synthetic filters rather than facet values.
      if (field.key === 'mimetype' || field.key === 'orientation') return

      const existingOptions = Array.isArray(field.options) ? field.options : []
      const optionKeys = existingOptions.reduce((acc, option) => {
        if (option && option.key) acc[option.key] = true
        return acc
      }, {})
      let facetOptions = []

      if (field.key === 'durationsecs') {
        facetOptions = durationDistribution.reduce((acc, item) => {
          const value = item && (item.key || item.label)
          if (!value || optionKeys[value]) return acc
          optionKeys[value] = true
          acc.push({
            key: value,
            label: this.formatRangeDistributionLabel(value, 's'),
          })
          return acc
        }, [])
      } else {
        const facetValues = facetMap[field.key] || []
        if (facetValues.length === 0) return
        facetOptions = facetValues.reduce((acc, facetValue) => {
          const value = facetValue && facetValue.value
          if (!value || optionKeys[value]) return acc
          optionKeys[value] = true
          acc.push({
            key: value,
            label: field.key === 'exchange' ? (exchangeToTitleMap[value] || value) : value,
          })
          return acc
        }, [])
      }

      field.options = [...existingOptions, ...facetOptions]
    })
  }

  renderFilterDialog() {
    if (!this.state.showFilterDialog) return '';
    const formDefinition = JSON.parse(JSON.stringify(this.filterFormDefinition || ddSearchFilterFieldDef.fieldDef))
    formDefinition.formType = 'edit'
    formDefinition.steps[0].fields.unshift({
      key: 'filterDate',
      type: 'date',
      label: 'Day (CST)',
      hint: 'Select Day',
      defaultValue: this.formatSelectedDate(this.state.selectedDate),
      // eslint-disable-next-line camelcase
      v_required: { value: false, err: 'Select Day' },
      placement: 'left',
    })
    const filterValues = {}
    formDefinition.steps[0].fields.forEach((field) => {
      if (field.key === 'filterDate') {
        filterValues[field.key] = this.formatSelectedDate(this.state.selectedDate)
      } else if (this.state.filters && this.state.filters[field.key] !== undefined) {
        filterValues[field.key] = this.state.filters[field.key]
      } else if (field.key === 'tags' && this.tag && Array.isArray(field.options) && field.options.some((option) => option.key === this.tag)) {
        filterValues[field.key] = [this.tag]
      } else if (field.defaultValue !== undefined) {
        filterValues[field.key] = field.defaultValue
      }
    })
    Helper.populateFormDefinitionValues(formDefinition, filterValues)
    return (<DynamicFormDialog
      customSubmit={this.onFilterSubmit}
      formDefinition={formDefinition}
      isOpen={this.state.showFilterDialog}
      onClosed={() => this.setState({ showFilterDialog: false })}
    />
    )
  }

}
const Styles = StyleSheet.create({
  statsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 5
  },
  searchContainer: {
    width: '100%',
    flex: 1,
    minWidth: 0
  },
  actionIconImage: {
    width: 20,
    height: 20
  },
  icons: {
    fontSize: 30,
    color: '#fff',
    marginRight: 12,
    background: 'rgb(228, 228, 228)',
    borderRadius: 8,
    width: 40,
    height: 40,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center'
  },
  statsInnerContainer: {
    display: 'flex',
    gap: 15,
    borderBottom: '1px solid #d7d7d7b5',
    padding: '5px 0px',
    width: 'max-content'
  },
  dpText: {
    fontWeight: 'bold',
    backgroundColor: '#f5f5f5',
    padding: '3px 6px',
    borderRadius: 4,
    minWidth: 20,
    textAlign: 'center'
  },
  statsValueText: {
    backgroundColor: '#f5f5f5',
    padding: '3px 6px',
    borderRadius: 4,
    minWidth: 20,
    textAlign: 'center'
  },
  statsValues: {
    display: 'flex',
    alignItems: 'center',
    gap: 10
  },
  venueColumn: {
    display: 'flex',
    gap: 7,
    flexDirection: 'column'
  },
  spanValue: {},
  img: {
    height: 30,
  },
  line2: {
    fontSize: 12,
  },
  renderAboveTable: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: 10
  },
  circleFill: {
    width: 18,
    height: 18,
    borderRadius: '50%',
  },
  fullWidth: {
    width: '100%',
  },
  mainContainer: {
    backgroundColor: AppTheme.primaryBg,
    width: '100%',
    '@media (max-width: 1025px)': {
      width: '97vw !important'
    }
  },
  eachChartHolder: {
  },
  eachChartHolder2: {
    width: '100%'
  },
  chartsContainer: {
    marginTop: '5px 0px',
    margin: '15px 0px',
    width: '100%',
  },
  // ddSearchStatsBody: {
  //   minWidth: '100% !important',
  //   width: '100%'
  // },
  chartOuterWrap: {
    background: '#fff',
    height: 214,
    borderRadius: 16
  },
  chartOuterWrap2: {
    background: '#fff',
    borderRadius: 16
  },
  chartBlock: {
    borderRadius: 16,
    padding: '10px 10px 10px 10px',
    height: 160
  },
  chartTitle: {
    fontSize: 16,
    color: '#121212',
    padding: 4
  },
  chartCanvas: {
    marginBottom: 10
  },
  statsHolder: {
    padding: '0 10px'
  },
  noChartMessage: {
    display: 'flex',
    justifyContent: 'center',
    height: '100%',
    flexDirection: 'column',
    textAlign: 'center'
  },
  tagHolder: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8,
    margin: '6px 0',
    alignItems: 'center'
  },
  descrText: {
    marginTop: 6,
    marginBottom: 6
  },
  tagChip: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '4px 10px',
    borderRadius: 999,
    backgroundColor: '#F3F4F6',
    color: '#222222',
    fontSize: 12,
    lineHeight: 1.2
  },
  aiJobStatusLine: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    borderTop: '1px solid #E5E7EB',
    marginTop: 8,
    paddingTop: 8,
    whiteSpace: 'nowrap'
  },
  modalHeader: {
    padding: 20,
    paddingLeft: 30,
    paddingRight: 30,
    paddingBottom: 14
  },
  modalTitle: {
    color: '#222222',
    fontSize: 22,
    paddingRight: 40,
    wordBreak: 'break-word'
  },
  modalCloseButton: {
    position: 'absolute',
    top: 23,
    right: 30,
    padding: 0,
    border: 'none',
    backgroundColor: 'transparent',
    display: 'flex',
    outline: 'none',
    cursor: 'pointer',
  },
  detailContent: {
    padding: '10px 30px 30px 30px',
    maxHeight: '70vh',
    overflowY: 'auto'
  },
  detailRow: {
    display: 'grid',
    gridTemplateColumns: '260px minmax(0, 1fr)',
    borderBottom: '1px solid #eeeeee',
    padding: '10px 0',
    gap: 16,
    '@media (max-width: 640px)': {
      gridTemplateColumns: '1fr',
      gap: 4
    }
  },
  detailKey: {
    color: '#5f6368',
    fontSize: 13,
    fontWeight: 600,
    wordBreak: 'break-word'
  },
  detailDescr: {
    color: '#8a8f94',
    fontSize: 11,
    fontWeight: 400,
    lineHeight: 1.4,
    marginTop: 4
  },
  detailValue: {
    color: '#222222',
    fontSize: 13,
    lineHeight: 1.5,
    wordBreak: 'break-word',
    whiteSpace: 'pre-wrap'
  },
  detailPre: {
    margin: 0,
    fontFamily: 'Red Hat Display, sans-serif',
    fontSize: 12,
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word'
  },
  dialogRoot: {
    zIndex: 13000,
  },
  dialogPaper: {
    borderRadius: AppTheme.borderRadius
  },
  filterIconWrap: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    width: 44,
    height: 44,
    borderRadius: '50%',
    backgroundColor: '#fff',
    boxShadow: '0px 2px 8px rgba(0,0,0,0.12)',
    flexShrink: 0,
    overflow: 'hidden',
  },
  singleFilterBar: {
    display: 'flex',
    gap: '10px'
  },
  filterChipsRow: {
    display: 'flex !important',
    gap: '15px !important',
    marginBottom: '15px !important',
    flexWrap: 'wrap'
  },
  filterChip: {
    backgroundColor: 'rgb(255, 255, 255) !important',
    padding: '10px !important',
    borderRadius: '6px !important',
    fontSize: '14px !important'
  },
  filterResetButton: {
    backgroundColor: '#fff',
    padding: '10px 14px',
    borderRadius: 6,
    fontSize: 14,
    border: '0px solid #d7d7d7',
    cursor: 'pointer',
    color: '#020BC3',
  },
  infoBlock: {
    display: 'flex !important',
    flexDirection: 'column',
    maxWidth: 500,
    fontSize: 12,
    gap: 5
  }
});



// WEBPACK FOOTER //
// ./src/screens/admin/DdSearch.js